export const BARCODE_SUPPORTED_FORMATS = ['ean_8', 'ean_13', 'upc_a', 'upc_e', 'itf'];
